import LinearProgress from '@mui/material/LinearProgress';

export function LinearProgressLoading(props) {
  return <LinearProgress variant="determinate" {...props} />;
}
